module.exports = __webpack_public_path__ + "static/media/adam-portrait.63935b74.png";